"use client";

import { useArtisanatCategoryStore } from "@/app/store/useArtisanatData";
import ArtisanatCard from "@/components/ArtisanatCard";
import { FitnessGymScroll } from "@/components/FitnessGymScroll";
import HeaderPage from "@/components/header-page";
import { useEffect } from "react";
import { useTranslations, useLocale } from 'next-intl';

export default function ArtisanatsClient() {
    const t = useTranslations();
    const locale = useLocale();
    const { artisanats, error, loading, fetchArtisanats } = useArtisanatCategoryStore();
    
    useEffect(() => {
        fetchArtisanats();
    }, [fetchArtisanats]);

    const renderArtisanatCard = (item: any, index: number) => (
        <ArtisanatCard item={item} />
    );

    return (
        <div dir={locale === 'ar' ? 'rtl' : 'ltr'}>
            <HeaderPage
                title={t('navigation.artisanats')}
                breadcrumbs={[
                    { label: t('common.home'), href: "/" },
                    { label: t('navigation.artisanats'), href: "/artisanats" },
                ]}
            />
            {loading && (
                <div className="container mx-auto px-4 py-8">
                    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
                        {Array.from({ length: 8 }).map((_, i) => (
                            <div
                                key={i}
                                className="rounded-xl overflow-hidden border animate-pulse"
                            >
                                <div className="h-48 bg-gray-200" />
                                <div className="p-4 space-y-3">
                                    <div className="h-4 bg-gray-200 rounded w-3/4" />
                                    <div className="h-3 bg-gray-200 rounded w-full" />
                                    <div className="h-3 bg-gray-200 rounded w-5/6" />
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            )}
            {error && (
                <div className="container mx-auto px-4 py-8">
                    <p className="text-center text-red-500">
                        {t('artisanats.errorMessage')}
                    </p>
                </div>
            )}
            {!loading && !error && (
                <div className="container mx-auto px-4 py-8">
                    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
                        {artisanats.map((item, index) => (
                            <div key={item.id || index}>
                                <ArtisanatCard item={item} />
                            </div>
                        ))}
                    </div>
                </div>
            )}
        </div>
    );
}
